export default (state = [], { type, payload }) => {
  switch (type) {
    case 'SET_STATES':
      return payload
    default:
      return state
  }
}